export default function Identity() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <p className="text-4xl md:text-5xl font-serif text-gray-800 leading-tight mb-6">
              "Excellence Through Technical Precision & Operational Integrity"
            </p>
            <p className="text-lg text-[#FF6B35] font-semibold">The L&A Advantage</p>
          </div>

          <div className="lg:col-span-3 space-y-8">
            <div className="flex items-start space-x-4 border-l-2 border-[#2E5C8A] pl-6">
              <div className="w-12 h-12 flex items-center justify-center bg-[#2E5C8A] rounded-full flex-shrink-0">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Fully Licensed & Insured</h3>
                <p className="text-gray-600 leading-relaxed">Comprehensive coverage and full compliance with Florida state regulations, ensuring your project is protected from start to finish.</p>
              </div>
            </div>

            <div className="flex items-start space-x-4 border-l-2 border-[#FF6B35] pl-6">
              <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-full flex-shrink-0">
                <i className="ri-award-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Premium Market Products</h3>
                <p className="text-gray-600 leading-relaxed">We exclusively source and install top-tier flooring materials that combine extreme durability with superior aesthetics for lasting value.</p>
              </div>
            </div>

            <div className="flex items-start space-x-4 border-l-2 border-gray-400 pl-6">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-400 rounded-full flex-shrink-0">
                <i className="ri-team-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Industry's Most Qualified Personnel</h3>
                <p className="text-gray-600 leading-relaxed">Our team brings decades of combined expertise in technical consulting, precision installation, and project management excellence.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
